<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      textColor: 'white',
      bgColor: 'primary',
      icon: 'fad fa-circle-info',
    }"
    size="sm"
  >
    <template #body>
      <QList>
        <QItem v-for="item in modalData" :key="item.key">
          <QItemSection avatar>
            <QIcon color="primary" :name="item.icon" />
          </QItemSection>
          <QItemSection>
            <QItemLabel>
              <h4>{{ t(item.title) }}</h4>
            </QItemLabel>
            <QItemLabel caption>
              {{ t(item.subtitle) }}
            </QItemLabel>
          </QItemSection>
        </QItem>
      </QList>
    </template>
    <template #footer>
      <section class="row justify-center">
        <QBtn v-close-popup color="secondary" no-caps class="q-px-lg" :label="$t('ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_ACTION')" />
      </section>
    </template>
  </ExtracadabraModal>
</template>

<script setup>
  import { computed, watch, onUnmounted } from "vue";
  import { useI18n } from "vue-i18n";
  import { ExtracadabraModal } from "@core/components/modals";
  import { StatusBar } from "@core/plugins/mobile";

  // Modal content configuration for different contract types
  const MODAL_CONTENT = {
    AE: [
      {
        key: "salary",
        icon: "fad fa-euro-sign",
        title: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_SALARY",
        subtitle: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_SALARY_SUBTITLE",
      },
      {
        key: "insurance",
        icon: "fad fa-umbrella-simple",
        title: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_INSURANCE",
        subtitle: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_INSURANCE_SUBTITLE",
      },
      {
        key: "replace",
        icon: "fad fa-arrows-rotate",
        title: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_REPLACE",
        subtitle: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_REPLACE_SUBTITLE",
      },
      {
        key: "management",
        icon: "fad fa-file-invoice",
        title: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_MANAGEMENT",
        subtitle: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_MANAGEMENT_SUBTITLE",
      },
    ],
    INTERIM: [
      {
        key: "guidance",
        icon: "fad fa-user-tie",
        title: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_SALARY_INTERIM",
        subtitle: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_SALARY_SUBTITLE_INTERIM",
      },
      {
        key: "replace",
        icon: "fad fa-arrows-rotate",
        title: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_REPLACE_INTERIM",
        subtitle: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_REPLACE_SUBTITLE_INTERIM",
      },
      {
        key: "management",
        icon: "fad fa-file-invoice",
        title: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_MANAGEMENT",
        subtitle: "ETAB.PAGES.DEMANDS.CREATION.@PRICING_MODAL_MANAGEMENT_SUBTITLE_INTERIM",
      },
    ],
  };

  const props = defineProps({
    opened: {
      type: Boolean,
      default: false,
    },
    isInterim: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["update:opened"]);

  const { t } = useI18n();

  let statusbarDelay;

  const internalOpen = computed({
    get: () => props.opened,
    set: () => emit("update:opened", false),
  });

  const modalData = computed(() => {
    return props.isInterim ? MODAL_CONTENT.INTERIM : MODAL_CONTENT.AE;
  });

  watch(
    () => props.opened,
    (value) => {
      if (value === true) {
        // since the modal appears after an animation, we need to match the time of animation before changing color
        statusbarDelay = setTimeout(() => {
          StatusBar.setWhiteBackground();
        }, 50);
      } else {
        // we put back the pricing style
        StatusBar.setBlackBackground();
      }
    },
  );
  onUnmounted(() => {
    clearTimeout(statusbarDelay);
  });
</script>
